// Hook para busca de municípios por nome (qualquer estado), com debounce.
// Usado no campo "Natural de (Município)" do cadastro.

import { useCallback, useRef } from 'react';
import { addressService } from '../services';

const MIN_CHARS = 3;
const DEBOUNCE_MS = 400;

// Referência estável para quem não passa `estados` — um `estados = []` inline
// no parâmetro cria um array novo a cada chamada do hook, o que quebraria a
// identidade de `buscarMunicipios` (useCallback abaixo) a cada render e faria
// o efeito de busca no SearchableSelect (que depende dessa função) disparar
// de novo repetidamente mesmo sem o usuário digitar.
const SEM_ESTADOS = [];

export const useMunicipioSearch = (estados = SEM_ESTADOS) => {
  // Referência ao setTimeout do debounce, para poder cancelar se o usuário continuar digitando
  const timeoutRef = useRef(null);

  const buscarMunicipios = useCallback((termo) => {
    return new Promise((resolve) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);

      const termoLimpo = termo.trim();
      if (termoLimpo.length < MIN_CHARS) {
        resolve([]);
        return;
      }

      timeoutRef.current = setTimeout(async () => {
        try {
          const response = await addressService.searchCities(termoLimpo, estados);
          resolve(response.data);
        } catch (error) {
          resolve([]);
        }
      }, DEBOUNCE_MS);
    });
  }, [estados]);

  return { buscarMunicipios, minChars: MIN_CHARS };
};
